import { Menu, MenuProps } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type MenuItem = Required<MenuProps>["items"][number];

const items: MenuItem[] = [
  {
    label: "Request a Quote",
    key: "/quote/3d_printing",
  },
  {
    label: "Resources & Example Work",
    key: "/resources",
  },
  // {
  //   label: 'Navigation Three - Submenu',
  //   key: 'SubMenu',
  //   icon: <SettingOutlined />,
  //   children: [
  //     {
  //       type: 'group',
  //       label: 'Item 1',
  //       children: [
  //         { label: 'Option 1', key: 'setting:1' },
  //         { label: 'Option 2', key: 'setting:2' },
  //       ],
  //     },
  //     {
  //       type: 'group',
  //       label: 'Item 2',
  //       children: [
  //         { label: 'Option 3', key: 'setting:3' },
  //         { label: 'Option 4', key: 'setting:4' },
  //       ],
  //     },
  //   ],
  // },
];
const Header: React.FC = () => {
  const [current, setCurrent] = useState("quote");
  const navigate = useNavigate();
  const location = useLocation();

  const onClick: MenuProps["onClick"] = (e) => {
    setCurrent(e.key);
    navigate(e.key);
  };

  useEffect(() => {
    setCurrent(
      (items.find((item) => item?.key === location.pathname)?.key as string) ??
        "quote"
    );
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="bg-primary p-8 sticky z-index-1000">
        <a href="https://wellstronics3d.com/">
          <img src="logo.svg" alt="Logo" />
        </a>
      </div>
      <Menu
        onClick={onClick}
        selectedKeys={[current]}
        mode="horizontal"
        items={items}
      />
    </>
  );
};

export default Header;
